const LOCALSTORAGE_KEY = 'currentUnitId';
const I_NEED_CURRENT_UNIT = 'I_NEED_CURRENT_UNIT';

let currentUnitId: string = I_NEED_CURRENT_UNIT;

function getFromLocalStorage(): string | null {
  return localStorage.getItem(LOCALSTORAGE_KEY);
}

function loadFromLocalStorage(): void {
  currentUnitId = getFromLocalStorage() || I_NEED_CURRENT_UNIT;
}

loadFromLocalStorage();

export default {
  get: () => { return currentUnitId },
  set: (id: string) => { currentUnitId = id },
  remove: () => {
    currentUnitId = I_NEED_CURRENT_UNIT;
    localStorage.removeItem(LOCALSTORAGE_KEY);
  },

  isUpToDate: () => {
    return currentUnitId === getFromLocalStorage();
  },

  loadFromLocalStorage,
  saveToLocalStorage: () => {
    localStorage.setItem(LOCALSTORAGE_KEY, currentUnitId.toString());
  },
};
